import getUrlForEnv, { services } from "@irati/utils/endpoints/getUrlForEnv";
var endpoints = {
    globalLogin: function () { return getUrlForEnv(services.LOGIN_SERVICE, "/v2/global-login"); },
    ghostLogin: function (tenantId) { return getUrlForEnv(services.LOGIN_SERVICE, "/v2/internal-admin/ghost/" + tenantId); },
    loginChallenge: function () { return getUrlForEnv(services.LOGIN_SERVICE, "/v2/login-challenge"); },
    requestForgotPassword: function () { return getUrlForEnv(services.LOGIN_SERVICE, "/v2/forgot-password"); },
    setForgotPassword: function () { return getUrlForEnv(services.LOGIN_SERVICE, "/v2/confirm-forgot-password"); },
    setPassword: function () { return getUrlForEnv(services.LOGIN_SERVICE, "/v2/change-password"); },
    validateToken: function () { return getUrlForEnv(services.PERMISSIONS_SERVICE, "/v2/validate-token"); },
    setCredentials: function () { return "/api/v1/set-credentials"; },
    getCredentials: function () { return "/api/v1/get-credentials"; }
};
export default endpoints;
